import React, { Component } from 'react';

import AdminLayout from './../layout';

import { getTransactionList, transactionExport } from './../../../API/FetchCall';

import DataTable from 'react-data-table-component';

const $ = require('jquery')

//$.DataTable = require('datatables.net')



class partnerTransactions extends Component {

    constructor(props) {
        super(props);
        this.state = {
           logged: localStorage.getItem("authentication"),
           auth_data: JSON.parse(localStorage.getItem("user_data")),
           dataSet: []
        }
    }

    componentDidMount() {

        this.UserDataList();
    }

    exportExcel = (e) => {
        this.transactionExport()

    }

    transactionExport = async () => {
        try {
            const res = await transactionExport();
            if (res.status == 1) {
                window.open(res.path);
                // window.location.href(res.path)
            }
        } catch (error) {
            this.setState({ error: true });
        }
    };

    UserDataList = async () => {
        try {
            let req = JSON.stringify({ role: 1 });
            const res = await getTransactionList(req);
            if (res.status == 1) {
                console.log('location_list', res.list)
                this.datatabledata(res.list);
            }

        } catch (error) {
            this.setState({ error: true });
        }
    };

    datatabledata(data) {

        console.log('data', data)
        this.setState({
            dataSet: data
        })
        this.el = $(this.el)
        this.el.DataTable(
            {
                data: this.state.dataSet,
                columns: [
                    { data: 's_no' },
                    { data: 'created_date' },
                    { data: 'razorpay_payment_id' },
                    { data: 'invoice_no' },
                    { data: 'name' },
                    { data: 'user_type' },
                    { data: 'email_id' },
                    { data: 'plan_id' },
                    { data: 'amount' },
                    { data: 'action' },
                ]

            }
        )
    }

  render() {
  
 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                  <div class="col-12 grid-margin">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title">Transactions</h4>
                         

                        <div className="content-top col-md-12 col-xs-12">

                                <div className="custom-form form-inline col-md-12 col-xs-12 h-small pad-top">
                                    <div className="row">
                                        <div className="hdr-row">
                                            <div className="pull-right">
                                                <div className="dropdown menu-item">
                                                    <button className="btn btn-success btn-sm dropdown-toggle btn-arrow" onClick={this.exportExcel}>
                                                        <i className="fa fa-file-excel-o" aria-hidden="true"></i> Export to Excel
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="main-content col-md-12 col-xs-12">
                                <div className="box-shadow-custom">
                                    <div className="table-responsive content-sec col-md-12 col-xs-12 pad-no mar-t-no">
                                        <table className="table table-custom-design table-striped dataTable" ref={el => this.el = el}>
                                            <thead>
                                                <tr>
                                                    <th className="tabledata">S.No</th>
                                                    <th className="tabledata">Date</th>
                                                    <th className="tabledata">RazorPay Id</th>
                                                    <th className="tabledata">Invoice</th>
                                                    <th className="tabledata">Partner Name</th>
                                                    <th className="tabledata">Type</th>
                                                    <th className="tabledata">Email Id</th>
                                                    <th className="tabledata">Package Name</th>
                                                    <th className="tabledata">Amount</th>
                                                    <th className="tabledata">Action</th>
                                                </tr>
                                            </thead>

                                        </table>
                                    </div>
                                </div>

                            </div>                         
                 

                      </div>
                    </div>
                  </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default partnerTransactions;


// WEBPACK FOOTER //
// ./src/components/bewise/partners/transactions.jsx